const steeringNetworks = {
  Achmea:
    'https://www.averoachmea.nl/vind-een-schadeherstelbedrijf/',
  Schadegarant: 'https://www.schadegarant.nl/',
  Topherstel: 'http://www.topherstel.nl/',
  others: '/#',
};

export default steeringNetworks;
